<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="sidebar-right"
    bg-variant="white"
    right
    lazy
    backdrop
    no-header
    shadow
    :width="sidebarWidth"
    @shown="checkUnsavedNewGood"
    @hidden="reset"
    ref="sidebar"
  >
    <template v-slot:default="{ hide }">
      <div v-if="isRefVisible" @click="closeRefs" class="close-ref"></div>
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(saveFormData)" autocomplete="off">
            <h2 v-if="addGood">Добавление товара</h2>
            <h2 v-else>Редактирование товара</h2>
            <b-row>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <validation-provider
                  ref="GoodsNumericDT"
                  :name="'Номер товара в ДТ'"
                  :rules="{ min: 1, max: 3, required: true, regex: /^\d+$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-1"
                    label="Номер товара в ДТ"
                    label-for="input-1"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsNumericDT) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-1"
                      :class="{ 'form-input': true, 'filled-field': (!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsNumericDT), 'required-field': !(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsNumericDT) }"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsNumericDT"
                      placeholder="Номер товара в ДТ"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <validation-provider
                  ref="GTDID"
                  :name="'Регистрационный номер ДТ'"
                  :rules="{ min: 23, max: 23, required: true, regex: /(^\d{5}.{3}[/](((0[1-9]|1[0-9]|2[0-8])(0[1-9]|1[012]))|((29|30|31)(0[13578]|1[02]))|((29|30)(0[4,6,9]|11)))\d{2}[/]{1}[0-9A-Za-zА-Яа-я]{1,7}$)|(^\d{8}[/]2902\d{2}[/]{1}[0-9A-Za-zА-Яа-я]{1,7}$)/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-2"
                    label="Регистрационный номер ДТ"
                    label-for="input-2"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GTDID) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-2"
                      v-mask="'#####XXX/######/#######'"
                      :class="{ 'form-input': true, 'filled-field': (!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GTDID), 'required-field': !(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GTDID) }"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GTDID"
                      @click="changePlaceholder"
                      @blur="GTDIDPlaceholder = 'Регистрационный номер ДТ'"
                      :placeholder="GTDIDPlaceholder"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <validation-provider
                  ref="GoodsCode"
                  :name="'Код товара по ТНВЭД'"
                  :rules="{ max: 10, evenAmountOfChars: goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsCode }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-3"
                    label="Код товара по ТНВЭД"
                    label-for="input-3"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-3"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsCode) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GoodsCode"
                      placeholder="Код товара по ТНВЭД"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12">
                <custom-input
                  ref="GoodsDescription"
                  inputId="GoodsDescription"
                  inputName="Описание товара"
                  type="simple"
                  :disabled="notForEdit"
                  :inputValidationRules="{ max: 32768, required: true }"
                  :edited="true"
                  :required="true"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                ></custom-input>
              </b-col>
            </b-row>
            <h4 class="form-title">Вес, количество</h4>
            <b-row>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="GrossWeightQuantity"
                  :name="'Вес товара, брутто'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-7"
                    label="Вес брутто"
                    label-for="input-7"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GrossWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-7"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GrossWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GrossWeightQuantity"
                      placeholder="Вес брутто"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="NetWeightQuantity"
                  :name="'Вес товара, нетто'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-8"
                    label="Вес нетто"
                    label-for="input-8"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].NetWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-8"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].NetWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].NetWeightQuantity"
                      placeholder="Вес нетто"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="NetWeightQuantity"
                  :name="'Вес упаковки (кг)'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-9"
                    label="Вес упаковки"
                    label-for="input-9"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].WeightTare) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-9"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].WeightTare) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].WeightTare"
                      placeholder="Вес упаковки"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  ref="NetWeightQuantity"
                  :name="'Вес брутто и упаковки'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-10"
                    label="Вес брутто и упаковки"
                    label-for="input-10"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GrossTareWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-10"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GrossTareWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].GrossTareWeightQuantity"
                      placeholder="Вес брутто и упаковки"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <validation-provider
                  ref="SupplementaryGoodsQuantity"
                  :name="'Количество товара'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/, required: Boolean((goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].MeasureUnitQualifierCode && (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].MeasureUnitQualifierCode.length > 0)) || (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].MeasureUnitQualifierName && (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].MeasureUnitQualifierName.length > 0))) }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-11"
                    label="Количество товара"
                    label-for="input-11"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].SupplementaryGoodsQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-11"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].SupplementaryGoodsQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].SupplementaryGoodsQuantity"
                      placeholder="Количество товара"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <custom-input
                  ref="MeasureUnitQualifierName"
                  inputId="MeasureUnitQualifierName"
                  inputName="Название единицы измерения товара"
                  :inputValidationRules="{ max: 13 }"
                  :inputItems="nsiMeasurement"
                  :targetInput="targetInput"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'abbr', label: 'Аббревиатура' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :inputRelatedFields="[
                    { MeasureUnitQualifierCode: 'code' }
                  ]"
                  :loadOnFocus="true"
                  :getData="loadNsiMeasurement"
                  :disabled="notForEdit"
                  :delay="1"
                  query="p"
                  select="abbr"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
              <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                <custom-input
                  ref="MeasureUnitQualifierCode"
                  inputId="MeasureUnitQualifierCode"
                  inputName="Код единицы измерения товара"
                  :inputValidationRules="{ max: 3 }"
                  :inputItems="nsiMeasurement"
                  :targetInput="targetInput"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'abbr', label: 'Аббревиатура' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :inputRelatedFields="[
                    { MeasureUnitQualifierName: 'abbr' }
                  ]"
                  :loadOnFocus="true"
                  :getData="loadNsiMeasurement"
                  :disabled="notForEdit"
                  :delay="1"
                  query="p"
                  select="code"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
            </b-row>
            <h4 class="form-title">Дополнительно</h4>
            <b-row>
              <b-col xl="6" lg="6" md="6" sm="6" cols="12">
                <validation-provider
                  ref="Procedure"
                  :name="'Габариты товара'"
                  :rules="{ max: 250 }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-14"
                    label="Габариты товара"
                    label-for="input-14"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].Dimensions) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-14"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].Dimensions) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].Dimensions"
                      placeholder="Габариты товара"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="6" lg="6" md="6" sm="6" cols="12">
                <validation-provider
                  ref="VolumeQuantity"
                  :name="'Объем товара'"
                  :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-15"
                    label="Объем"
                    label-for="input-15"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].VolumeQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-15"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].VolumeQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].VolumeQuantity"
                      placeholder="Объем"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12">
                <validation-provider
                  ref="WarehouseName"
                  :name="'Склад (помещение, название и тд.)'"
                  :rules="{ max: 40 }"
                  v-slot="validationContext">
                  <b-form-group
                    id="input-group-16"
                    label="Склад (помещение, название и тд.)"
                    label-for="input-16"
                    :label-class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].WarehouseName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      id="input-16"
                      :class="(!!goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].WarehouseName) ? 'form-input filled-field' : 'form-input'"
                      v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].WarehouseName"
                      placeholder="Склад (помещение, название и тд.)"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <h4 class="form-title">Грузовые места</h4>
            <b-row v-for="(item, index) in goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM" :key="index">
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <validation-provider
                  :ref="'PlacesQuantity-' + index"
                  :name="'Кол-во грузовых мест-' + index"
                  :rules="{ max: 11, regex: /^\d+$/, required: Boolean((item.PlacesQuantity && (item.PlacesQuantity.length > 0)) || (item.PlacesDescription && (item.PlacesDescription.length > 0)) || (item.PlacesCode && (item.PlacesCode > 0)) || (item.WeightPackage && (item.WeightPackage > 0))) }"
                  v-slot="validationContext">
                  <b-form-group
                    :id="'input-group-17-' + index"
                    label="Количество"
                    :label-for="'input-17-' + index"
                    :label-class="(!!item.PlacesQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                    :invalid-feedback="validationContext.errors[0]"
                  >
                    <b-form-input
                      :id="'input-17-' + index"
                      :class="(!!item.PlacesQuantity) ? 'form-input filled-field' : 'form-input'"
                      v-model="item.PlacesQuantity"
                      placeholder="Количество"
                      :disabled="notForEdit"
                      :state="getValidationState(validationContext)"
                      @change="updateIdbData"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <custom-input
                  :ref="'PlacesDescription-' + index"
                  :inputId="'PlacesDescription-' + index"
                  :inputName="'Описание вида грузовых мест-' + index"
                  :index="index"
                  :inputValidationRules="{ max: 250 }"
                  :inputItems="nsiPacking"
                  :targetInput="targetInput"
                  :loadOnFocus="true"
                  :disabled="notForEdit"
                  parent="COMMISSIONSHIPMENTPLACES_ITEM"
                  customPlaceholder="Описание"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :inputRelatedFields="[
                    { PlacesCode: 'code' }
                  ]"
                  :delay="1"
                  query="p"
                  select="name"
                  :getData="loadNsiPacking"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <custom-input
                  :ref="'PlacesCode-' + index"
                  :inputId="'PlacesCode-' + index"
                  :inputName="'Код вида грузовых мест-' + index"
                  :index="index"
                  :inputValidationRules="{ max: 2 }"
                  :inputItems="nsiPacking"
                  :targetInput="targetInput"
                  :loadOnFocus="true"
                  :disabled="notForEdit"
                  parent="COMMISSIONSHIPMENTPLACES_ITEM"
                  customPlaceholder="Код"
                  :inputFields="[
                    { key: 'code', label: 'Код' },
                    { key: 'name', label: 'Наименование' }
                  ]"
                  :inputRelatedFields="[
                    { PlacesDescription: 'name' }
                  ]"
                  select="code"
                  :getData="loadNsiPacking"
                  @setForm="setModel($event)"
                  @setTargetInput="setTarget($event)"
                  @closeRefs="closeRefs"
                  @setRefVisible="setVisible($event)"
                  @setRelatedFields="setRelated($event)"
                ></custom-input>
              </b-col>
              <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                <div class="d-flex align-items-start">
                  <validation-provider
                    :ref="'WeightPackage-' + index"
                    class="w-100"
                    :name="'Вес одного грузового места-' + index"
                    :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                    v-slot="validationContext">
                    <b-form-group
                      :id="'input-group-20-' + index"
                      label="Вес"
                      :label-for="'input-20-' + index"
                      :label-class="(!!item.WeightPackage) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                      :invalid-feedback="validationContext.errors[0]"
                    >
                      <b-form-input
                        :id="'input-20-' + index"
                        :class="(!!item.WeightPackage) ? 'form-input filled-field' : 'form-input'"
                        v-model="item.WeightPackage"
                        placeholder="Вес"
                        :disabled="notForEdit"
                        :state="getValidationState(validationContext)"
                        @change="updateIdbData"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                  <b-button :disabled="notForEdit" @click="removePermissiveDocuments(index)" :class="{ 'ml-3': true, 'mr-3': index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.length - 1) }" squared size="sm" variant="outline-secondary">
                    <font-awesome-icon icon="fa-solid fa-minus" />
                  </b-button>
                  <b-button :disabled="notForEdit" v-if="index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.length - 1)" @click="addPermissiveDocuments" squared size="sm" variant="outline-success">
                    <font-awesome-icon icon="fa-solid fa-plus" />
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <h4 class="form-title mr-3">Контейнеры</h4>
            <div class="d-flex align-items-center justify-content-between">
              <b-form-checkbox id="containersSwitch" @change="updateIdbData" class="mr-3" v-model="goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].EmptyAllContainer" name="check-button" switch>
                Все порожние
              </b-form-checkbox>
              <!-- div>
                <b-button class="excel-link" variant="link"><font-awesome-icon icon="fa-solid fa-upload" class="mr-2" />Загрузить из excel</b-button>
                <b-button class="excel-link" variant="link"><font-awesome-icon icon="fa-solid fa-download" class="mr-2" />Скачать шаблон excel</b-button>
              </div -->
            </div>
            <!-- span>:style="(goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length >= 6) ? 'overflow-y: scroll; overflow-x: hidden; max-height: 240px;' : ''"</span-->
            <!-- span>v-for="(item, index) in goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM"</span-->
            <div>
              <b-row v-for="(item, index) in containers" :key="'container-' + containersKey + '-' + index">
                <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                  <validation-provider
                    :ref="'ContainerID-' + index"
                    :name="'Номер контейнера-' + index"
                    :rules="{ max: 40, required: Boolean((item.ContainerKind && (item.ContainerKind.length > 0)) || (item.WeightTare && (item.WeightTare > 0)) || (item.GrossTareWeight && (item.GrossTareWeight > 0)) || (item.SealId && (item.SealId > 0))) }"
                    v-slot="validationContext">
                    <b-form-group
                      :id="'input-group-21-' + index"
                      label="Номер контейнера"
                      :label-for="'input-21-' + index"
                      :label-class="(!!item.ContainerID) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                      :invalid-feedback="validationContext.errors[0]"
                    >
                      <b-form-input
                        :id="'input-21-' + index"
                        class="form-input"
                        :class="(!!item.ContainerID) ? 'form-input filled-field' : 'form-input'"
                        v-model="item.ContainerID"
                        placeholder="Номер контейнера"
                        :disabled="notForEdit"
                        :state="getValidationState(validationContext)"
                        @change="updateIdbData"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col xl="2" lg="2" md="2" sm="2" cols="12">
                  <custom-input
                    :ref="'ContainerKind-' + index"
                    :inputId="'ContainerKind-' + index"
                    :inputName="'Код вида грузовых мест-' + index"
                    :index="index"
                    :inputValidationRules="{ max: 2 }"
                    :inputItems="nsiPacking"
                    :targetInput="targetInput"
                    :loadOnFocus="true"
                    :disabled="notForEdit"
                    parent="COMMISSIONSHIPMENTCONTAINER_ITEM"
                    customPlaceholder="Код"
                    :inputFields="[
                      { key: 'code', label: 'Код' },
                      { key: 'name', label: 'Наименование' }
                    ]"
                    select="code"
                    :delay="1"
                    query="p"
                    :getData="loadNsiPackingContainers"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                  ></custom-input>
                </b-col>
                <b-col xl="2" lg="2" md="2" sm="2" cols="12">
                  <validation-provider
                    :ref="'WeightTare-' + index"
                    :name="'Вес тары-' + index"
                    :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                    v-slot="validationContext">
                    <b-form-group
                      :id="'input-group-23-' + index"
                      label="Вес тары"
                      :label-for="'input-23-' + index"
                      :label-class="(!!item.WeightTare) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                      :invalid-feedback="validationContext.errors[0]"
                    >
                      <b-form-input
                        :id="'input-23-' + index"
                        :class="(!!item.WeightTare) ? 'form-input filled-field' : 'form-input'"
                        v-model="item.WeightTare"
                        placeholder="Вес тары"
                        :disabled="notForEdit"
                        :state="getValidationState(validationContext)"
                        @change="updateIdbData"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col xl="2" lg="2" md="2" sm="2" cols="12">
                  <validation-provider
                    :ref="'GrossTareWeight-' + index"
                    :name="'Вес гросс-' + index"
                    :rules="{ max: 25, regex: /^\d{0,18}[.]?\d{0,6}?$/ }"
                    v-slot="validationContext">
                    <b-form-group
                      :id="'input-group-24-' + index"
                      label="Вес гросс"
                      :label-for="'input-24-' + index"
                      :label-class="(!!item.GrossTareWeight) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                      :invalid-feedback="validationContext.errors[0]"
                    >
                      <b-form-input
                        :id="'input-24-' + index"
                        :class="(!!item.GrossTareWeight) ? 'form-input filled-field' : 'form-input'"
                        v-model="item.GrossTareWeight"
                        placeholder="Вес гросс"
                        :disabled="notForEdit"
                        :state="getValidationState(validationContext)"
                        @change="updateIdbData"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                  <div class="d-flex align-items-start">
                    <validation-provider
                      :ref="'SealId-' + index"
                      :name="'Номер пломбы-' + index"
                      class="w-100"
                      :rules="{ sealIdMaxLength: item.SealId }"
                      v-slot="validationContext">
                      <b-form-group
                        :id="'input-group-25-' + index"
                        label="Номер пломбы"
                        :label-for="'input-25-' + index"
                        :label-class="(!!item.SealId) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                        :invalid-feedback="validationContext.errors[0]"
                      >
                        <b-form-input
                          :id="'input-25-' + index"
                          :class="(!!item.SealId) ? 'form-input filled-field' : 'form-input'"
                          v-model="item.SealId"
                          placeholder="Номер пломбы"
                          :disabled="notForEdit"
                          :state="getValidationState(validationContext)"
                          @change="updateIdbData"
                          trim
                        ></b-form-input>
                      </b-form-group>
                    </validation-provider>
                    <b-button :disabled="notForEdit" @click="removeContainerNew(index)" :class="{ 'ml-3': true }" squared size="sm" variant="outline-secondary">
                      <font-awesome-icon icon="fa-solid fa-minus" />
                    </b-button>
                    <!-- b-button :disabled="notForEdit" @click="removeContainer(index)" :class="{ 'ml-3': true, 'mr-3': index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length - 1) }" squared size="sm" variant="outline-secondary">
                      <font-awesome-icon icon="fa-solid fa-minus" />
                    </b-button>
                    <b-button :disabled="notForEdit" v-if="index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length - 1)" @click="addContainer" squared size="sm" variant="outline-success">
                      <font-awesome-icon icon="fa-solid fa-plus" />
                    </b-button -->
                  </div>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col>
                <b-pagination
                  :key="paginationKey"
                  size="sm"
                  v-model="currentPage"
                  :total-rows="rowsContainers"
                  :per-page="perPage"
                  @change="changeContainers"
                ></b-pagination>
              </b-col>
              <b-col class="text-right">
                <span v-b-tooltip.hover title="Добавить контейнер">
                  <b-button :disabled="notForEdit" @click="addContainerNew" squared size="sm" variant="outline-success">
                    <font-awesome-icon icon="fa-solid fa-plus" />
                  </b-button>
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="text-left">
                <b-button class="collapsed" @click="collapseDocumentsVisible = !collapseDocumentsVisible" v-b-toggle="'collapse-COMMISSIONSHIPMENTDocument'" variant="link">Документы, по которым перевозится товар (необязательно)</b-button>
              </b-col>
            </b-row>
            <b-collapse id="collapse-Document" v-model="collapseDocumentsVisible" class="pt-3">
              <b-row v-for="(item, index) in goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM" :key="'document-' + index">
                <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                  <custom-input
                    :ref="'ModeCode-' + index"
                    :inputId="'ModeCode-' + index"
                    :inputName="'Код-' + index"
                    :index="index"
                    :inputValidationRules="{ max: 30 }"
                    :inputItems="nsiDocuments"
                    :targetInput="targetInput"
                    :disabled="notForEdit"
                    parent="COMMISSIONSHIPMENTDOCUMENT_ITEM"
                    customPlaceholder="Код документа"
                    :inputFields="[
                      { key: 'code', label: 'Код' },
                      { key: 'name', label: 'Наименование' }
                    ]"
                    :inputRelatedFields="[
                      { DocumentName: 'name' }
                    ]"
                    query="p"
                    :delay="1"
                    select="code"
                    :getData="loadNsiDocuments"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                    @setRelatedFields="setRelated($event)"
                  ></custom-input>
                </b-col>
                <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                  <custom-input
                    :ref="'DocumentName-' + index"
                    :inputId="'DocumentName-' + index"
                    :inputName="'Наименование документа-' + index"
                    :index="index"
                    :inputValidationRules="{ max: 250, required: Boolean(item.ModeCode && (item.ModeCode.length > 0)) }"
                    :inputItems="nsiDocuments"
                    :targetInput="targetInput"
                    :disabled="notForEdit"
                    parent="COMMISSIONSHIPMENTDOCUMENT_ITEM"
                    customPlaceholder="Наименование документа"
                    :inputFields="[
                      { key: 'code', label: 'Код' },
                      { key: 'name', label: 'Наименование' }
                    ]"
                    :inputRelatedFields="[
                      { ModeCode: 'code' }
                    ]"
                    query="p"
                    :delay="1"
                    select="name"
                    :getData="loadNsiDocuments"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                    @setRelatedFields="setRelated($event)"
                  ></custom-input>
                </b-col>
                <b-col xl="2" lg="2" md="2" sm="2" cols="12">
                  <validation-provider
                    :ref="'DocumentNumber-' + index"
                    :name="'Номер документа-' + index"
                    :rules="{ max: 50 }"
                    v-slot="validationContext">
                    <b-form-group
                      :id="'input-group-28-' + index"
                      label="Номер документа"
                      :label-for="'input-28-' + index"
                      :label-class="(!!item.DocumentNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
                      :invalid-feedback="validationContext.errors[0]"
                    >
                      <b-form-input
                        :id="'input-28-' + index"
                        class="form-input"
                        :class="(!!item.DocumentNumber) ? 'form-input filled-field' : 'form-input'"
                        v-model="item.DocumentNumber"
                        placeholder="Номер документа"
                        :disabled="notForEdit"
                        :state="getValidationState(validationContext)"
                        @change="updateIdbData"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="4" cols="12">
                  <div class="d-flex align-items-start">
                    <custom-datepicker
                      class="w-100"
                      :ref="'DocumentDate-' + index"
                      :inputId="'DocumentDate-' + index"
                      :inputName="'Дата документа-' + index"
                      :index="index"
                      :disabled="notForEdit"
                      parent="COMMISSIONSHIPMENTDOCUMENT_ITEM"
                      customPlaceholder="Дата документа"
                      :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
                      @setForm="setModel($event)"
                    ></custom-datepicker>
                    <b-button :disabled="notForEdit" @click="removePlace(index)" :class="{ 'ml-3': true, 'mr-3': index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length - 1) }" squared size="sm" variant="outline-secondary">
                      <font-awesome-icon icon="fa-solid fa-minus" />
                    </b-button>
                    <b-button :disabled="notForEdit" v-if="index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length - 1)" @click="addPlace" squared size="sm" variant="outline-success">
                      <font-awesome-icon icon="fa-solid fa-plus" />
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="text-left">
                <b-button class="collapsed" @click="collapseDangerVisible = !collapseDangerVisible" variant="link">Класс опасности груза (необязательно)</b-button>
              </b-col>
            </b-row>
            <b-collapse id="collapse-danger" v-model="collapseDangerVisible" class="pt-3">
              <b-row v-for="(item, index) in goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM" :key="'danger-' + index">
                <b-col xl="3" lg="3" md="3" sm="3" cols="12">
                  <custom-input
                    :ref="'UNNO-' + index"
                    :inputId="'UNNO-' + index"
                    :inputName="'Код UNNO-' + index"
                    :index="index"
                    :inputValidationRules="{ max: 3 }"
                    :inputItems="nsiHazardClasses"
                    :targetInput="targetInput"
                    :disabled="notForEdit"
                    parent="COMMISSIONSHIPMENTDANGER_ITEM"
                    customPlaceholder="Код IMO"
                    :inputFields="[
                      { key: 'code', label: 'Код' },
                      { key: 'name', label: 'Наименование' }
                    ]"
                    :inputRelatedFields="[
                      { DangerIMO: 'name' }
                    ]"
                    query="p"
                    :delay="1"
                    select="code"
                    :getData="loadNsiHazardClasses"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                    @setRelatedFields="setRelated($event)"
                  ></custom-input>
                </b-col>
                <b-col xl="9" lg="9" md="9" sm="9" cols="12">
                  <div class="d-flex align-items-start">
                    <custom-input
                      class="w-100"
                      :ref="'DangerIMO-' + index"
                      :inputId="'DangerIMO-' + index"
                      :inputName="'Класс опасности IMO-' + index"
                      :index="index"
                      :inputValidationRules="{ max: 250 }"
                      :inputItems="nsiHazardClasses"
                      :targetInput="targetInput"
                      :disabled="notForEdit"
                      parent="COMMISSIONSHIPMENTDANGER_ITEM"
                      customPlaceholder="Код IMO"
                      :inputFields="[
                        { key: 'code', label: 'Код' },
                        { key: 'name', label: 'Наименование' }
                      ]"
                      :inputRelatedFields="[
                        { UNNO: 'code' }
                      ]"
                      query="p"
                      :delay="1"
                      select="name"
                      :getData="loadNsiHazardClasses"
                      @setForm="setModel($event)"
                      @setTargetInput="setTarget($event)"
                      @closeRefs="closeRefs"
                      @setRefVisible="setVisible($event)"
                      @setRelatedFields="setRelated($event)"
                    ></custom-input>
                    <b-button :disabled="notForEdit" @click="removeDangerCargo(index)" :class="{ 'ml-3': true, 'mr-3': index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length - 1) }" squared size="sm" variant="outline-secondary">
                      <font-awesome-icon icon="fa-solid fa-minus" />
                    </b-button>
                    <b-button :disabled="notForEdit" v-if="index === (goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length - 1)" @click="addDangerCargo" squared size="sm" variant="outline-success">
                      <font-awesome-icon icon="fa-solid fa-plus" />
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row>
              <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="text-left">
                <b-button class="collapsed" @click="collapseProcedureVisible = !collapseProcedureVisible" variant="link">Таможенная процедура (необязательно)</b-button>
              </b-col>
            </b-row>
            <b-collapse id="collapse-procedure" v-model="collapseProcedureVisible" class="pt-3">
              <b-row>
                <b-col xl="6" lg="6" md="6" sm="6" cols="12">
                  <custom-input
                    ref="Procedure"
                    inputId="Procedure"
                    inputName="Тип таможенной процедуры"
                    :inputValidationRules="{}"
                    :inputItems="ProcedureOptions"
                    :targetInput="targetInput"
                    :disabled="notForEdit"
                    :inputFields="[{ key: 'text', label: 'Тип' }]"
                    :loadOnFocus="true"
                    :delay="1"
                    query="p"
                    select="value"
                    :getData="() => { return promise.resolve() }"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                  ></custom-input>
                </b-col>
                <b-col xl="6" lg="6" md="6" sm="6" cols="12">
                  <custom-input
                    ref="CodeProcedure"
                    inputId="CodeProcedure"
                    inputName="Код таможенной процедуры"
                    :inputValidationRules="{ max: 2 }"
                    :inputItems="nsiProcedures"
                    :targetInput="targetInput"
                    :inputFields="[
                      { key: 'code', label: 'Код' },
                      { key: 'name', label: 'Наименование' }
                    ]"
                    :getData="loadNsiProcedures"
                    :disabled="notForEdit"
                    select="code"
                    :loadOnFocus="true"
                    :delay="1"
                    query="p"
                    @setForm="setModel($event)"
                    @setTargetInput="setTarget($event)"
                    @closeRefs="closeRefs"
                    @setRefVisible="setVisible($event)"
                    @setRelatedFields="setRelated($event)"
                  ></custom-input>
                </b-col>
              </b-row>
            </b-collapse>
            <b-row class="mb-3 mt-3">
              <b-col xl="6" lg="12" md="12" sm="12" cols="12">
                <div class="d-md-flex d-lg-flex align-items-start">
                  <span v-b-tooltip.hover :title="notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                    <b-button
                      variant="success"
                      @click="scrollIfError"
                      :disabled="notForEdit"
                      type="submit"
                      class="btn-action-success mr-3 mb-2"
                      squared size="sm"
                    >
                    <span v-if="addGood">Добавить товар</span>
                    <span v-else>Изменить товар</span>
                  </b-button>
                  </span>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { extend } from 'vee-validate'
  import idbapi from '../../../idbapi/idb.js'
  import CustomInput from '../../CustomInput'
  import CustomDatepicker from '../../CustomDatepicker'
  export default {
    name: "AddGoodsPage.vue",
    components: {
      CustomInput,
      CustomDatepicker
    },
    props: ['addGood', 'notForEdit'],
    data () {
      return {
        targetInput: null,
        isRefVisible: false,
        promise: window.Promise,
        goodsForm: {
          COMMISSIONSHIPMENTGOODS_ITEM: [
            {
              GoodsNumericDT: null, // Номер товара в ДТ +
              GTDID: null, // Номер ДТ +
              GoodsCode: null, // Код ТН ВЭД +
              Procedure: null, // Планируемая к заявлению таможенная процедура
              CodeProcedure: null, // Планируемая к заявлению таможенная процедура: Код
              GoodsDescription: null, // Наименование груза +
              GrossWeightQuantity: null, // Вес товара, брутто (кг)
              NetWeightQuantity: null, // Вес товара, нетто (кг) +
              WeightTare: null, // Вес без груза (тара)
              GrossTareWeightQuantity: null, // Вес брутто и контейнера (кг)
              SupplementaryGoodsQuantity: null, // Количество товара
              MeasureUnitQualifierCode: null, // Код единицы измерения товара
              MeasureUnitQualifierName: null, // Название единицы измерения при возможности ее указания
              Dimensions: null, // Размеры товара (длина, высота, ширина)
              VolumeQuantity: null, // Объем с припуском
              WarehouseName: null, // Склад +
              EmptyAllContainer: false,
              COMMISSIONSHIPMENTPlaces: {
                COMMISSIONSHIPMENTPLACES_ITEM: [
                  {
                    PlacesQuantity: null, // Кол-во грузовых мест
                    PlacesDescription: null, // Описание вида грузовых мест (коробок, упаковок, паллет и т.д.)
                    PlacesCode: null, // Код вида грузовых мест
                    WeightPackage: null // Вес одного грузового места (поддон, паллета и т.д)
                  }
                ]
              },
              COMMISSIONSHIPMENTContainer: {
                COMMISSIONSHIPMENTCONTAINER_ITEM: [
                  {
                    ContainerID: null, // Номер контейнера
                    ContainerKind: null, // Тип контейнера
                    WeightTare: null, // Вес тары
                    GrossTareWeight: null, // Вес гросс (кг)
                    SealId: null // Номер пломбы
                  }
                ]
              },
              COMMISSIONSHIPMENTDocument: {
                COMMISSIONSHIPMENTDOCUMENT_ITEM: [
                  {
                    ModeCode: null, // Вид документа
                    DocumentName: null, // Наименование документа
                    DocumentNumber: null, // Номер документа
                    DocumentDate: null // Дата документа
                  }
                ]
              },
              COMMISSIONSHIPMENTDanger: {
                COMMISSIONSHIPMENTDANGER_ITEM: [
                  {
                    UNNO: null, // Код UNNO
                    DangerIMO: null // Груз: класс опасности IMO
                  }
                ]
              }
            }
          ]
        },
        ProcedureOptions: [
          { value: 'ИМ', text: 'ИМ' },
          { value: 'ЭК', text: 'ЭК' },
          { value: 'ТТ', text: 'ТТ' }
        ],
        sidebarWidth: '',
        GTDIDPlaceholder: 'Регистрационный номер ДТ',
        collapseDocumentsVisible: false,
        collapseDangerVisible: false,
        collapseProcedureVisible: false,
        currentPage: 1,
        rowsContainers: null,
        perPage: 10,
        containers: [],
        previousPage: 1,
        paginationKey: 1,
        containersKey: 1
      }
    },
    watch: {
      'goodsForm.COMMISSIONSHIPMENTGOODS_ITEM': {
        handler (val) {
          if (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length > 0) {
            for (let i = 0; i < val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length; i++) {
              if (val && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].ModeCode && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].ModeCode.length > 0))) this.collapseDocumentsVisible = true
              if (val && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentName && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentName.length > 0))) this.collapseDocumentsVisible = true
              if (val && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentNumber && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentNumber.length > 0))) this.collapseDocumentsVisible = true
              if (val && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentDate && (val[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentDate.length > 0))) this.collapseDocumentsVisible = true
            }
          }
          if (val[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length > 0) {
            for (let i = 0; i < val[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length; i++) {
              if (val && (val[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[i].UNNO && (val[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[i].UNNO.length > 0))) this.collapseDangerVisible = true
              if (val && (val[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[i].DangerIMO && (val[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[i].DangerIMO.length > 0))) this.collapseDangerVisible = true
            }
          }
          if (val[0].Procedure && (val[0].Procedure.length > 0)) this.collapseProcedureVisible = true
          if (val[0].CodeProcedure && (val[0].CodeProcedure.length > 0)) this.collapseProcedureVisible = true
        },
        deep: true
      },
    },
    computed: {
      ...mapState(
        {
          nsiProcedures: state => state.commissionShipment.nsiProcedures,
          nsiMeasurement: state => state.commissionShipment.nsiMeasurement,
          nsiPacking: state => state.commissionShipment.nsiPacking,
          nsiDocuments: state => state.commissionShipment.nsiDocuments,
          nsiHazardClasses: state => state.commissionShipment.nsiHazardClasses,
          mobile: state => state.mobile,
          tablet: state => state.tablet,
          desktop: state => state.desktop,
          largeDesktop: state => state.largeDesktop
        }
      )
    },
    mounted () {
      this.calcSidebarWidth()
      extend('sealIdMaxLength', {
        validate (value) {
          const ids = value.split(', ')
          let isValid = null
          for (let i = 0; i < ids.length; i++) {
            if (ids[i].length > 20) {
              isValid = false
            } else {
              isValid = true
            }
          }
          return isValid
        },
        params: ['length'],
        message: 'Номер каждой пломбы не может быть более 20 символов'
      })
      extend('evenAmountOfChars', {
        validate (value) {
          const even = ((value.length % 2) === 0)
          return even && (value.length > 2)
        },
        params: ['length'],
        message: 'Код товара по ТН ВЭД может содержать 4, 6, 8, 10 символов'
      })
    },
    methods: {
      reset () {
        if (!this.addGood) this.resetSidebarData()
        this.currentPage = 1
        this.rowsContainers = null
        this.perPage = 10
        this.containers = []
        this.previousPage = 1
        this.paginationKey = Math.random()
        this.containersKey = Math.random()
      },
      removeContainerNew (index) {
        let goodsForm_goodIndex = null
        if (this.previousPage === 1) {
          goodsForm_goodIndex = index
        } else {
          goodsForm_goodIndex = (this.previousPage*10 - 10) + index
        }
        if (!(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length === 1)) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(goodsForm_goodIndex, 1)
        }
        setTimeout(() => {
          this.rowsContainers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length
          if ((index === 0) && ((this.previousPage*10 - 10) === this.rowsContainers)) {
            this.previousPage = this.previousPage - 1
            this.currentPage = this.previousPage
          }
          this.containers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.slice()
          this.containers = this.containers.splice(((this.previousPage - 1)*10), 10)
          this.$nextTick(() => {
            for (let i = 0; i < this.containers.length; i++) {
              if (this.$refs['ContainerKind-' + i] && (this.$refs['ContainerKind-' + i].length > 0)) {
                this.$refs['ContainerKind-' + i][0].model = this.containers[i].ContainerKind
              }
            }
          })
          // this.containersKey++
        }, 0)
      },
      addContainerNew () {
        if ((this.currentPage === 1) && (this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length === 1)) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(0, 1, this.containers[0])
        }
        this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.push(
          {
            ContainerID: null, // Номер контейнера
            ContainerKind: null, // Тип контейнера
            WeightTare: null, // Вес тары
            GrossTareWeight: null, // Вес гросс (кг)
            SealId: null // Номер пломбы
          }
        )
        this.rowsContainers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length
        this.currentPage = Math.ceil(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length/10)
        this.previousPage = this.currentPage

        this.containers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.slice()
        this.containers = this.containers.splice(((this.currentPage - 1)*10), 10)

        setTimeout(() => {
          if (this.containers && (this.containers.length === 1)) {
            this.paginationKey++
          }
          // this.containersKey++
          this.$nextTick(() => {
            for (let i = 0; i < this.containers.length; i++) {
              if (this.$refs['ContainerKind-' + i] && (this.$refs['ContainerKind-' + i].length > 0)) {
                this.$refs['ContainerKind-' + i][0].model = this.containers[i].ContainerKind
              }
            }
          })
        }, 10)
      },
      changeContainers (event) {
        if (this.containers.length === 10) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 10, this.containers[0], this.containers[1], this.containers[2], this.containers[3], this.containers[4], this.containers[5], this.containers[6], this.containers[7], this.containers[8], this.containers[9])
        } else if (this.containers.length === 9) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 9, this.containers[0], this.containers[1], this.containers[2], this.containers[3], this.containers[4], this.containers[5], this.containers[6], this.containers[7], this.containers[8])
        } else if (this.containers.length === 8) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 8, this.containers[0], this.containers[1], this.containers[2], this.containers[3], this.containers[4], this.containers[5], this.containers[6], this.containers[7])
        } else if (this.containers.length === 7) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 7, this.containers[0], this.containers[1], this.containers[2], this.containers[3], this.containers[4], this.containers[5], this.containers[6])
        } else if (this.containers.length === 6) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 6, this.containers[0], this.containers[1], this.containers[2], this.containers[3], this.containers[4], this.containers[5])
        } else if (this.containers.length === 5) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 5, this.containers[0], this.containers[1], this.containers[2], this.containers[3], this.containers[4])
        } else if (this.containers.length === 4) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 4, this.containers[0], this.containers[1], this.containers[2], this.containers[3])
        } else if (this.containers.length === 3) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 3, this.containers[0], this.containers[1], this.containers[2])
        } else if (this.containers.length === 2) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 2, this.containers[0], this.containers[1])
        } else if (this.containers.length === 1) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(((this.previousPage - 1)*10), 1, this.containers[0])
        }
        setTimeout(() => {
          this.containers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.slice()
          this.containers = this.containers.splice(((event - 1)*10), 10)
          this.$nextTick(() => {
            for (let i = 0; i < this.containers.length; i++) {
              if (this.$refs['ContainerKind-' + i] && (this.$refs['ContainerKind-' + i].length > 0)) {
                this.$refs['ContainerKind-' + i][0].model = this.containers[i].ContainerKind
              }
            }
          })
          this.previousPage = event
          // this.containersKey++
        }, 0)
      },
      setModel (event) {
        if (('index' in event) && ('parent' in event) && (event.index !== null) && (event.parent !== null)) {
          if (event.parent === 'COMMISSIONSHIPMENTPLACES_ITEM') {
            const name = event.fieldName.split('-')[0]
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTPlaces'][event.parent][event.index][name] = event.item
          } else if (event.parent === 'COMMISSIONSHIPMENTCONTAINER_ITEM') {
            const name = event.fieldName.split('-')[0]
            let item_index = null
            if (this.previousPage === 1) {
              item_index = event.index
            } else {
              item_index = (this.previousPage*10 - 10) + event.index
            }
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTContainer'][event.parent][item_index][name] = event.item
          } else if (event.parent === 'COMMISSIONSHIPMENTDOCUMENT_ITEM') {
            const name = event.fieldName.split('-')[0]
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTDocument'][event.parent][event.index][name] = event.item
          } else if (event.parent === 'COMMISSIONSHIPMENTDANGER_ITEM') {
            const name = event.fieldName.split('-')[0]
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTDanger'][event.parent][event.index][name] = event.item
          } else {
            const name = event.fieldName.split('-')[0]
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0][event.parent][event.index][name] = event.item
          }
        } else {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0][event.fieldName] = event.item
        }
        this.updateIdbData()
      },
      closeRefs () {
        const keys = Object.keys(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0])
        for (let i = 0; i < keys.length; i++) {
          if (this.$refs[keys[i]] && this.$refs[keys[i]].items) {
            this.$refs[keys[i]].items = []
          }
        }
        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.length; i++) {
          this.$refs['PlacesDescription-' + i][0].items = []
          this.$refs['PlacesCode-' + i][0].items = []
        }
        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length; i++) {
          if (this.$refs['ContainerKind-' + i] && (this.$refs['ContainerKind-' + i].length > 0)) {
            this.$refs['ContainerKind-' + i][0].items = []
          }
        }
        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length; i++) {
          this.$refs['ModeCode-' + i][0].items = []
          this.$refs['DocumentName-' + i][0].items = []
        }
        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length; i++) {
          this.$refs['UNNO-' + i][0].items = []
          this.$refs['DangerIMO-' + i][0].items = []
        }
        this.isRefVisible = false
      },
      setTarget (event) {
        this.targetInput = event
      },
      setRelated (event) {
        // console.log(event)
        event.relatedFields.map((field) => {
          const key = Object.keys(field)[0]
          if (event.parent === 'COMMISSIONSHIPMENTPLACES_ITEM') {
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTPlaces'][event.parent][event.index][key] = event.item[field[key]]
            this.$refs[key + '-' + event.index][0].model = event.item[field[key]]
          } else if (event.parent === 'COMMISSIONSHIPMENTDOCUMENT_ITEM') {
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTDocument'][event.parent][event.index][key] = event.item[field[key]]
            this.$refs[key + '-' + event.index][0].model = event.item[field[key]]
          } else if (event.parent === 'COMMISSIONSHIPMENTDANGER_ITEM') {
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0]['COMMISSIONSHIPMENTDanger'][event.parent][event.index][key] = event.item[field[key]]
            this.$refs[key + '-' + event.index][0].model = event.item[field[key]]
          } else {
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0][key] = event.item[field[key]]
            this.$refs[key].model = event.item[field[key]]
          }
          if (/^\d{4}-\d{2}-\d{2}$/.test(event.item[field[key]])) {
            let date = event.item[field[key]].split('-')
            date = date[2] + '.' + date[1] + '.' + date[0]
            this.$refs[key].model = date
          }
        })
        this.updateIdbData()
      },
      setVisible (event) {
        this.isRefVisible = event
      },
      checkUnsavedNewGood () {
        if (this.addGood) {
          idbapi.getPackageData().then(
            (documents) => {
              if (documents && (documents.length > 0)) {
                if (Object.keys(documents[0]).indexOf('unsavedNewGood' !== -1)) {
                  this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0] = Object.assign(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0], documents[0].unsavedNewGood)
                  this.$nextTick(() => {
                    this.setRefsModels()
                  })
                }
              } else {
                this.containers.push({
                  ContainerID: null, // Номер контейнера
                  ContainerKind: null, // Тип контейнера
                  WeightTare: null, // Вес тары
                  GrossTareWeight: null, // Вес гросс (кг)
                  SealId: null // Номер пломбы
                })
              }
            }
          )
        }
      },
      setRefsModels () {
        const keys = Object.keys(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0])
        for (let i = 0; i < keys.length; i++) {
          if ((keys[i] === 'MeasureUnitQualifierCode') ||
            (keys[i] === 'MeasureUnitQualifierName') ||
            (keys[i] === 'CodeProcedure') ||
            (keys[i] === 'Procedure') ||
            (keys[i] === 'GoodsDescription')) {
            this.$refs[keys[i]].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0][keys[i]]
          }
        }
        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.length; i++) {
          this.$refs['PlacesDescription-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[i].PlacesDescription
          this.$refs['PlacesCode-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[i].PlacesCode
        }

        /* for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length; i++) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[i].ContainerID = i
        } */

        this.rowsContainers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length
        this.containers = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.slice()
        this.containers = this.containers.splice(0, 10)

        setTimeout(() => {
          for (let i = 0; i < this.containers.length; i++) {
            this.$refs['ContainerKind-' + i][0].model = this.containers[i].ContainerKind
          }
        }, 100)

        /* for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length; i++) {
          this.$refs['ContainerKind-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[i].ContainerKind
        } */

        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length; i++) {
          this.$refs['ModeCode-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].ModeCode
          this.$refs['DocumentName-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentName
          this.$refs['DocumentDate-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[i].DocumentDate
        }
        for (let i = 0; i < this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length; i++) {
          this.$refs['UNNO-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[i].UNNO
          this.$refs['DangerIMO-' + i][0].model = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[i].DangerIMO
        }
      },
      async updateIdbData () {
        await idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              if (this.addGood) {
                idbapi.addUnsavedNewGood(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0])
              }
            } else {
              if (this.addGood) {
                this.$emit('saveEmptyPackageInIdb')
                setTimeout(() => {
                  idbapi.addUnsavedNewGood(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0])
                }, 200)
              }
            }
          }
        )
      },
      changePlaceholder () {
        this.GTDIDPlaceholder = '00000000/000000/0000000'
      },
      mergeEditedGoodsItem (item) {
        // console.log(item)
        Object.assign(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0], item)
        this.$nextTick(() => {
          this.setRefsModels()
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
      },
      calcSidebarWidth () {
        if (this.largeDesktop) {
          this.sidebarWidth = '1024px'
        }else if (this.desktop){
          this.sidebarWidth = '100%'
        } else if (this.mobile || this.tablet) {
          this.sidebarWidth = '100%'
        }
      },
      removeDangerCargo (index) {
        if (!(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length === 1)) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.splice(index, 1)
        }
      },
      addDangerCargo () {
        this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.push(
          {
            UNNO: null, // Код UNNO
            DangerIMO: null // Груз: класс опасности IMO
          }
        )
      },
      removePlace (index) {
        if (!(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length === 1)) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.splice(index, 1)
        }
      },
      addPlace () {
        this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.push(
          {
            ModeCode: null, // Вид документа
            DocumentName: null, // Наименование документа
            DocumentNumber: null, // Номер документа
            DocumentDate: null // Дата документа
          }
        )
      },
      /* removeContainer (index) {
        if (!(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length === 1)) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(index, 1)
        }
      },
      addContainer () {
        this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.push(
          {
            ContainerID: null, // Номер контейнера
            ContainerKind: null, // Тип контейнера
            WeightTare: null, // Вес тары
            GrossTareWeight: null, // Вес гросс (кг)
            SealId: null // Номер пломбы
          }
        )
      }, */
      removePermissiveDocuments (index) {
        if (!(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.length === 1)) {
          this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.splice(index, 1)
        }
      },
      addPermissiveDocuments () {
        this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.push(
          {
            PlacesQuantity: null, // Кол-во грузовых мест
            PlacesDescription: null, // Описание вида грузовых мест (коробок, упаковок, паллет и т.д.)
            PlacesCode: null, // Код вида грузовых мест
            WeightPackage: null // Вес одного грузового места (поддон, паллета и т.д)
          }
        )
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      resetSidebarData () {
        const props = Object.getOwnPropertyNames(this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0])
        for (let i = 0; i < props.length; i++) {
          if (props[i] === 'COMMISSIONSHIPMENTPlaces') {
            const CSPlacesLn = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.length
            if (CSPlacesLn > 1) {
              this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.splice(1, (CSPlacesLn - 1))
            }
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[0].PlacesQuantity = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[0].PlacesDescription = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[0].PlacesCode = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[0].WeightPackage = null
          } else if (props[i] === 'COMMISSIONSHIPMENTContainer') {
            const CSContainerLn = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length
            if (CSContainerLn > 1) {
              this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.splice(1, (CSContainerLn - 1))
            }
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].ContainerID = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].ContainerKind = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].WeightTare = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].GrossTareWeight = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].SealId = null
          } else if (props[i] === 'COMMISSIONSHIPMENTDocument') {
            const CSDocLn = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.length
            if (CSDocLn > 1) {
              this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM.splice(1, (CSDocLn - 1))
            }
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[0].ModeCode = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[0].DocumentName = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[0].DocumentNumber = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM[0].DocumentDate = null
          } else if (props[i] === 'COMMISSIONSHIPMENTDanger') {
            const CSDangerLn = this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.length
            if (CSDangerLn > 1) {
              this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM.splice(1, (CSDangerLn - 1))
            }
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[0].UNNO = null
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0].COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM[0].DangerIMO = null
          } else {
            this.goodsForm.COMMISSIONSHIPMENTGOODS_ITEM[0][props[i]] = null
          }
        }
        this.$refs.observer.reset()
        this.collapseDocumentsVisible = false
        this.collapseDangerVisible = false
        this.collapseProcedureVisible = false
      },
      scrollIfError () {
        /* setTimeout(() => {
          const el = document.querySelector('.invalid-feedback')
          if (el) {
            el.closest('.row').previousSibling.scrollIntoView()
          }
        }, 100) */
      },
      async saveFormData () {
        if (this.addGood) {
          await idbapi.deleteUnsavedNewGood()
          await this.$emit('addGoods', JSON.parse(JSON.stringify(this.goodsForm)))
        } else {
          await this.$emit('editGoods', JSON.parse(JSON.stringify(this.goodsForm)))
        }
        this.currentPage = 1
        this.rowsContainers = null
        this.perPage = 10
        this.containers = []
        this.previousPage = 1
        this.paginationKey = Math.random()
        this.$refs.sidebar.hide()
      },
      ...mapActions({
        loadNsiProcedures: 'commissionShipment/loadNsiProcedures',
        loadNsiMeasurement: 'commissionShipment/loadNsiMeasurement',
        loadNsiPacking: 'commissionShipment/loadNsiPacking',
        loadNsiPackingContainers: 'commissionShipment/loadNsiPackingContainers',
        loadNsiDocuments: 'commissionShipment/loadNsiDocuments',
        loadNsiHazardClasses: 'commissionShipment/loadNsiHazardClasses'
      })
    }
  }
</script>

<style lang="scss" scoped>
  h2 {
    margin-bottom: 20px;
    margin-top: 10px;
    color: #37474F;
    font-size: 25px;
    font-weight: 500;
    line-height: 28px;
  }
  #ProcedureOptions {
    border-radius: 0 !important;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  .GoodsDescription {
    border-radius: 0 !important;
  }
  .excel-link {
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    margin-bottom: 5px;
  }
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  .close-ref {
    height: 100%;
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: transparent;
    /* background-color: #989fa4; */
  }
</style>
